import { useTranslation } from "react-i18next";
import { TabsContent, TabsTrigger } from "@shadcn-in-nx/ui/tabs";
import { MessageSquare, Code2, Zap, Terminal } from "lucide-react";
import ConversationTab from "./ConversationTab";
import StepsTab from "./StepsTab";
import TriggersTab from "./TriggersTab";
import ExecutionTab from "./ExecutionTab";

export function AutomationTabTriggers() {
    const { t } = useTranslation();
    return (<>
        <TabsTrigger value="conversation" className="gap-1.5">
            <MessageSquare className="h-4 w-4" />{t("admin.automationPlayground.tabs.conversation")}
        </TabsTrigger>
        <TabsTrigger value="steps" className="gap-1.5">
            <Code2 className="h-4 w-4" />{t("admin.automationPlayground.tabs.steps")}
        </TabsTrigger>
        <TabsTrigger value="triggers" className="gap-1.5">
            <Zap className="h-4 w-4" />{t("admin.automationPlayground.tabs.triggers")}
        </TabsTrigger>
        <TabsTrigger value="execution" className="gap-1.5">
            <Terminal className="h-4 w-4" />{t("admin.automationPlayground.tabs.execution")}
        </TabsTrigger>
    </>);
}

export function AutomationTabContents({ data, execution, executionStatus }) {
    return (<>
        <TabsContent value="conversation"><ConversationTab data={data} /></TabsContent>
        <TabsContent value="steps"><StepsTab data={data} /></TabsContent>
        <TabsContent value="triggers"><TriggersTab data={data} /></TabsContent>
        <TabsContent value="execution"><ExecutionTab execution={execution} executionStatus={executionStatus} /></TabsContent>
    </>);
}
